import React, { type ReactElement } from 'react';

import styles from './SeoIndexable.module.scss';

import { useOrigin } from '@/hooks/origin/useOrigin';

type SeoIndexableProps = {
  children: ReactElement<{ tabIndex?: number }>;
  relativeUrl?: string;
  indexable?: boolean;
};

export const SeoIndexable = ({ children, indexable, relativeUrl }: SeoIndexableProps) => {
  const origin = useOrigin();

  if (indexable)
    return (
      <a href={`${origin}${relativeUrl}`} className={styles.Link}>
        {React.cloneElement(children, { tabIndex: -1 })}
      </a>
    );
  return children;
}
